import styles from "./DeliveryHighlights.module.scss";
import { Props } from "../../DeliveryAndGuaranteesMessageUI";
import { ClickAndCollect } from "../ClickAndCollect/ClickAndCollect";
import { ListWithIcon } from "@/components/DeliveryAndGuaranteesMessage/components/ListWithIcon";
import { checkTimedContentIsActive } from "@/components/ProductAccordion/components/ProductDeliveryOptionsAccordion/util/checkTimedContentIsActive.ts";

export const DeliveryHighlights = ({
  message,
  isClickAndCollectAvailable,
  isOverClickAndCollectThreshold,
  showClickAndCollect = "never",
  showFreeReturns = false,
  showFreeReturnsWithRestrictions = false,
  hideDeliveryMessage,
  returnsEndDate,
  returnsStartDate,
}: Props) => {
  if (hideDeliveryMessage) {
    return null;
  }

  const showClickAndCollectMessage =
    showClickAndCollect === "always" ||
    (showClickAndCollect === "available" && isClickAndCollectAvailable);

  const showTimedFrameCopy = checkTimedContentIsActive(
    returnsStartDate,
    returnsEndDate,
  );

  return (
    <ul data-testid="product:delivery-message" className={styles.message}>
      {showClickAndCollectMessage && (
        <ClickAndCollect
          isClickAndCollectAvailable={isClickAndCollectAvailable}
          isOverClickAndCollectThreshold={isOverClickAndCollectThreshold}
        />
      )}

      {message && (
        <ListWithIcon
          cssClasses={styles.deliveryMessage}
          textMessage={message}
          iconType="delivery"
        />
      )}
      {showFreeReturns && (
        <ListWithIcon
          cssClasses={styles.deliveryMessage}
          textMessage={` Free returns${showTimedFrameCopy ? " until 23 January" : ""}${showFreeReturnsWithRestrictions ? ", restrictions apply" : ""}`}
          iconType="returns"
        />
      )}
    </ul>
  );
};
